import { api } from "../.."

// função para cadastrar um adiantamento
const ApproversCreateAdvanceService = async (id: number, description: string, value: number) => {

    const response = await api.post(`approvers/advances/${id}`, {
        description, value
    });

    return response;

}
// função para cadastrar um adiantamento

export {
    ApproversCreateAdvanceService
}